import { render, staticRenderFns } from "./TlmAccordion.vue?vue&type=template&id=283599c7"
import script from "./TlmAccordion.vue?vue&type=script&lang=js"
export * from "./TlmAccordion.vue?vue&type=script&lang=js"
import style0 from "./TlmAccordion.vue?vue&type=style&index=0&id=283599c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports